// Libs
import _reduce from 'lodash/reduce'
import _map from 'lodash/map'
import _every from 'lodash/every'
import rewind from 'geojson-rewind'

// Utils
import traverse from 'fc-utils/traverse'
// Local
export function multiPolygonParser (geometry) {
  return {
    ...geometry,
    coordinates: _map(geometry.coordinates, (coordinates) => {
      const [[x]] = coordinates

      if (!Array.isArray(x)) {
        return [coordinates]
      }

      return coordinates
    }),
  }
}

export function polygonParser (geometry) {
  const [[x]] = geometry.coordinates

  if (Array.isArray(x)) {
    return multiPolygonParser({
      ...geometry,
      type: 'MultiPolygon',
    })
  }

  return geometry
}

export function geometryParser (geometry) {
  if (geometry.type === 'Polygon') {
    return polygonParser(geometry)
  } else if (geometry.type === 'MultiPolygon') {
    return multiPolygonParser(geometry)
  }

  return geometry
}

export function featuresToMultiPolygon (geoJSON) {
  const { geometry, properties } = _reduce(geoJSON.features, (acc, feature) => {
    const geometryOfFeature = feature.geometry || feature
    const { coordinates } = geometryOfFeature

    acc.geometry.coordinates.push(coordinates)
    acc.properties = {
      ...acc.properties,
      ...feature.properties,
    }

    return acc
  }, {
    geometry: {
      type: 'MultiPolygon',
      coordinates: [],
      properties: {},
    },
    properties: {},
  })

  return {
    type: 'Feature',
    geometry: geometryParser(geometry),
    properties,
  }
}

export function geometryCollectionToFeatureCollection (feature) {
  const type = traverse(['geometry', 'type'])(feature)

  if (type === 'GeometryCollection') {
    const geometries = traverse(['geometry', 'geometries'])(feature)

    return {
      type: 'FeatureCollection',
      properties: feature.properties,
      features: _map(geometries, featureGeoJson),
    }
  }

  return feature
}

export function featureWithGeometries (geoJSON) {
  const featuresArePolygons = _every(
    geoJSON.features,
    ({type, geometry}) => type === 'Polygon' || (geometry && geometry.type === 'Polygon')
  )

  if (featuresArePolygons) {
    return featuresToMultiPolygon(geoJSON)
  }

  return {
    type: 'Feature',
    geometry: {
      type: 'GeometryCollection',
      geometries: _map(geoJSON.features, (feature) => {
        const parsed = featureGeoJson(feature)

        return {
          ...parsed.geometry,
          properties: {
            ...parsed.geometry.properties,
            ...parsed.properties,
          },
        }
      }),
    },
    properties: geoJSON.properties,
  }
}

export function featureGeoJson (geoJSON) {
  if (geoJSON && geoJSON.type !== 'Feature') {
    return {
      type: 'Feature',
      geometry: geometryParser(geoJSON),
      properties: geoJSON.properties,
    }
  } else if (geoJSON) {
    return {
      ...geoJSON,
      geometry: geometryParser(geoJSON.geometry),
    }
  }

  return null
}

// Exports
export default function geoJson (maybeGeoJSON) {
  if (maybeGeoJSON) {
    try {
      const geoJSON = typeof maybeGeoJSON === 'string'
        ? JSON.parse(maybeGeoJSON)
        : maybeGeoJSON

      return rewind(geoJSON)
    } catch (error) {
      return null
    }
  }

  return null
}
